import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle } from "@phosphor-icons/react";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== confirm) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await api.post("/auth/accept-invite", { token, password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 1800);
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/40 p-6">
      <div className="w-full max-w-sm bg-card rounded-xl border border-border shadow-sm p-7" data-testid="accept-invite-card">
        {!token ? (
          <p className="text-center text-muted-foreground">This invite link is missing its token.</p>
        ) : done ? (
          <div className="text-center py-4">
            <CheckCircle size={40} weight="fill" className="text-success mx-auto" />
            <h1 className="font-heading text-xl font-semibold mt-3">You're all set!</h1>
            <p className="text-sm text-muted-foreground mt-1">Redirecting you to sign in…</p>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-2xl font-semibold tracking-tight">Set your password</h1>
            <p className="text-sm text-muted-foreground mt-1 mb-5">Create a password to activate your account.</p>
            <div className="space-y-3">
              <div><Label className="text-xs">New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="invite-pw" className="mt-1" /></div>
              <div><Label className="text-xs">Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="invite-pw-confirm" className="mt-1" onKeyDown={(e) => e.key === "Enter" && submit()} /></div>
            </div>
            <Button className="w-full mt-5" onClick={submit} disabled={busy} data-testid="invite-activate">{busy ? "Activating…" : "Activate account"}</Button>
          </>
        )}
      </div>
    </div>
  );
}
